import type { Types } from '@common/models';
import { tuneSubscribe } from '@common/talkn-config';
import Sequence from '@common/Sequence';

type Action = {
  type: string;
  tuneCh: Types['Ch'];
  postsTimelineStock: Types['Post'][];
};

export default (state: Types['Post'][] = [], action: Action) => {
  switch (action.type) {
    case 'SERVER_TO_API[EMIT]:fetchPosts':
    case `${Sequence.SERVER_TO_API_BROADCAST}${tuneSubscribe.statePosts}`:
      if (action.postsTimelineStock && action.postsTimelineStock.length > 0) {
        if (action.tuneCh.connection === action.postsTimelineStock[0].connection) {
          return [...state, ...action.postsTimelineStock];
        }
      }
      break;
  }
  return state;
};
